import React from "react";
import { AxSpinner } from "@dynata/axiom3";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="center-div">
      <AxSpinner size="large" />
    </div>
  )
}

export default LoadingSpinner;